import { render, staticRenderFns } from "./prelist.vue?vue&type=template&id=2ceac418&scoped=true&"
import script from "./prelist.vue?vue&type=script&lang=js&"
export * from "./prelist.vue?vue&type=script&lang=js&"
import style0 from "./prelist.vue?vue&type=style&index=0&id=2ceac418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceac418",
  null
  
)

export default component.exports